import { render, staticRenderFns } from "./LegalStatusApp.vue?vue&type=template&id=0a8c2d54&"
import script from "./LegalStatusApp.vue?vue&type=script&lang=js&"
export * from "./LegalStatusApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports